import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: null,
    currentCard: null
  },
  mutations: {
    SET_USER_INFO(state, data) {
      state.userInfo = data
    },
    SET_CURRENT_CARD(state, data) {
      state.currentCard = data
    }
  },
  actions: {},
  modules: {}
})